var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTick(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.388,
    height: 7.078
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Icon - Tick"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2b3236",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M9.329 1.06L3.561 6.328l-2.5-2.5",
    "data-name": "Path 3966"
  }))));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMC4zODgiIGhlaWdodD0iNy4wNzgiPjxnIGRhdGEtbmFtZT0iSWNvbiAtIFRpY2siPjxwYXRoIGZpbGw9Im5vbmUiIHN0cm9rZT0iIzJiMzIzNiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBzdHJva2Utd2lkdGg9IjEuNSIgZD0iTTkuMzI5IDEuMDYgMy41NjEgNi4zMjhsLTIuNS0yLjUiIGRhdGEtbmFtZT0iUGF0aCAzOTY2Ii8+PC9nPjwvc3ZnPg==";
export { SvgTick as ReactComponent };